import React from "react";
import { observer } from "mobx-react-lite";
import Icon from "@mdi/react";
import { mdiChevronLeft, mdiChevronRight } from "@mdi/js";
import { Button } from "@heroui/react";
import { contractorsStore } from "@/stores/ContractorsStore";

const MonthNavigator: React.FC = observer(() => {
  const { activeMonth, isUiBusy } = contractorsStore;
  const label = activeMonth
    .toLocaleString("ru-RU", { month: "long", year: "numeric" })
    .replace(/\s*г\.?\s*$/i, "");

  return (
    <div className="sc-month-nav" data-testid="contractors-month-nav">
      <Button
        isIconOnly
        variant="tertiary"
        size="sm"
        aria-label="Предыдущий месяц"
        className="icon-btn--card"
        isDisabled={isUiBusy}
        data-testid="contractors-month-prev-button"
        onPress={() => contractorsStore.goToPrevMonth()}
      >
        <Icon path={mdiChevronLeft} size={0.85} />
      </Button>
      <span className="sc-month-nav__label">{label}</span>
      <Button
        isIconOnly
        variant="tertiary"
        size="sm"
        aria-label="Следующий месяц"
        className="icon-btn--card"
        isDisabled={isUiBusy}
        data-testid="contractors-month-next-button"
        onPress={() => contractorsStore.goToNextMonth()}
      >
        <Icon path={mdiChevronRight} size={0.85} />
      </Button>
    </div>
  );
});

MonthNavigator.displayName = "MonthNavigator";
export default MonthNavigator;
